const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const DamageEvent = require('../../events/DamageEvent');
const BleedingCondition = require('../../conditions/BleedingCondition');
const { logError } = require('../../logger');

const InfectMind = function (battleState) {
  this.handle = 'infect_mind';
  this.magic = true;
  this.ranged = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    const ability = BattleCalc.getEquippedAbility(actor, this.handle);

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        // calculate bleed condition potency using a dummy damage event,
        // so we can apply stance adjustments, hero Affinities, etc.
        const bleedDamageDummy = new DamageEvent(
          battleState,
          actor,
          ability.potency,
          this
        );
        bleedDamageDummy.applyStanceAdjustments(victim);
        const bleed_potency = bleedDamageDummy.damage;

        const reflected = BattleCalc.rollForReflectMagic(victim);
        const finalActor = reflected ? victim : actor;
        const finalVictim = reflected ? actor : victim;

        // if the victim already has a bleeding condition with same instigator, add to its potency
        let bleeding = BattleCalc.getCondition(
          finalVictim,
          'bleeding',
          actor.uid
        );
        if (bleeding) {
          bleeding.potency += bleed_potency;
          battleState.updateCondition(finalVictim.uid, bleeding.uid);
        } else {
          bleeding = new BleedingCondition(
            finalActor,
            finalVictim,
            battleState,
            bleed_potency
          );
          battleState.onUnitCondition(bleeding);
        }

        var result = { bleeding };
        result.abilityHandle = this.handle;
        result.actorId = finalActor.uid;
        result.victimId = finalVictim ? finalVictim.uid : null;
        result.is_reflection = reflected;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'InfectMind',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim));
  };
};
module.exports = InfectMind;
